import APIService from '../api';

export interface ICohortValueCount {
  value: string;
  customers: number;
}

export interface ICohortCounts {
  dimension: string;
  values: ICohortValueCount[];
}

class CustomerCohortsService extends APIService {
  get resource() {
    return '/admin/customer-cohorts';
  }

  getCounts(dimension: string) {
    return this.get<ICohortCounts>(`${this.resource}/counts`, {
      params: { dimension }
    });
  }
}

export default CustomerCohortsService;
